module.exports = __webpack_public_path__ + "static/img/12.9ea983f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/gift/12.png
// module id = CJhl
// module chunks = 2